var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#CCE5FF",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5385C13 13.0364 13.1489 12.5456 13.4278 12.1282C13.7067 11.7107 14.1032 11.3854 14.567 11.1932C15.0309 11.0011 15.5413 10.9508 16.0337 11.0488C16.5261 11.1467 16.9784 11.3885 17.3334 11.7435C17.6884 12.0985 17.9302 12.5508 18.0281 13.0432C18.1261 13.5356 18.0758 14.046 17.8837 14.5099C17.6916 14.9737 17.3662 15.3702 16.9488 15.6491C16.5313 15.928 16.0405 16.0769 15.5385 16.0769V16.9231",
    fill: "#CCE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5385C13 13.0364 13.1489 12.5456 13.4278 12.1282C13.7067 11.7107 14.1032 11.3854 14.567 11.1932C15.0309 11.0011 15.5413 10.9508 16.0337 11.0488C16.5261 11.1467 16.9784 11.3885 17.3334 11.7435C17.6884 12.0985 17.9302 12.5508 18.0281 13.0432C18.1261 13.5356 18.0758 14.046 17.8837 14.5099C17.6916 14.9737 17.3662 15.3702 16.9488 15.6491C16.5313 15.928 16.0405 16.0769 15.5385 16.0769V16.9231",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5391,
    cy: 20.7698,
    r: 1,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks);
export default __webpack_public_path__ + "static/media/how-it-works.71799e3196d9c6cf58a1ebacff13c9a9.svg";
export { ForwardRef as ReactComponent };